import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { renderField } from '../../common/FormsControls.jsx';


const UserAboutForm = (props) => {
  return <form onSubmit={ props.handleSubmit } className="cabinet-user-about__form">
    <div className="form-group">
      <div>
        <Field placeholder={ gettext('О себе') }
               component={ renderField }
               element='auto_textarea'
               name='about'/>
      </div>
    </div>
    <div className="text-right">
      <button className="btn btn-primary btn-sm">{ gettext('Сохранить') }</button>
      <button className="btn btn-light btn-sm ml-1" onClick={ props.onReset }>{ gettext('Отменить') }</button>
    </div>
  </form>
};

export default compose(
  connect(state => ({ initialValues: { about: state.user.about } })),
  reduxForm({ form: 'userAboutForm' })
)(UserAboutForm)